import { CheckboxList } from "./CheckboxList";
import { DRIVER_COMPLIANCE_FILTER_OPTIONS } from "../constants/driver-profile";

const COMPLIANCE_STATUS_LIST = DRIVER_COMPLIANCE_FILTER_OPTIONS.filter(
  (option) => option.value
).map((option) => ({
  id: option.value,
  name: option.label,
}));

/**
 * Compliance status filter dropdown for the drivers list (same pattern as TagsFilterList).
 */
export const DriverComplianceFilterList = (props) => {
  function handleChange(val) {
    if (!val || val.length === 0) {
      props.onChange({
        title: props.value?.defaultText || "",
        value: "",
      });
      return;
    }

    const value = val.map(({ id }) => id).join(",");
    const title = val.map(({ name }) => name).join(",");

    props.onChange({ title, value });
  }

  return (
    <CheckboxList
      onChange={handleChange}
      objectKey="id"
      value={props.value?.value}
      data={COMPLIANCE_STATUS_LIST}
    />
  );
};
